import { render, staticRenderFns } from "./WarningView.vue?vue&type=template&id=038c332d&scoped=true"
import script from "./WarningView.vue?vue&type=script&lang=js"
export * from "./WarningView.vue?vue&type=script&lang=js"
import style0 from "./WarningView.vue?vue&type=style&index=0&id=038c332d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c332d",
  null
  
)

export default component.exports